import { Link } from 'react-router-dom';

const sidebarServices = [
  { label: 'Kasetli Tente', href: '/hizmetler/kasetli-tente' },
  { label: 'Körüklü Tente', href: '/hizmetler/koruklu-tente' },
  { label: 'Mafsallı Tente', href: '/hizmetler/mafsalli-tente' },
  { label: 'Bioklimatik Pergola', href: '/hizmetler/bioklimatik-pergola' },
  { label: 'Otomatik Pergola', href: '/hizmetler/otomatik-pergola' },
  { label: 'Zip Perde', href: '/hizmetler/zip-perde' },
  { label: 'Şeffaf Branda', href: '/hizmetler/seffaf-branda' },
];

const regions = ['Karşıyaka', 'Bornova', 'Buca', 'Gaziemir', 'Balçova', 'Narlıdere', 'Çiğli', 'Bayraklı', 'Konak', 'Menemen'];

export default function SeoArticle() {
  return (
    <section className="bg-white py-16 md:py-24" id="seo-icerik">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">

          {/* Ana içerik */}
          <div className="lg:col-span-2 space-y-14">

            {[
              {
                h2: 'İzmir Tente ve Dış Mekan Sistemleri',
                items: [
                  { h3: 'Şık ve Fonksiyonel Çözümler', p: 'Tente ve dış mekan sistemleri, açık alanları hem estetik hem de işlevsel kılan en etkili gölgelendirme çözümleri arasındadır. <strong>izmirdetenteci.com</strong> olarak sunduğumuz ürün yelpazesi; kasetli tente, körüklü tente, mafsallı tente, bioklimatik pergola, otomatik pergola, rollingroof pergola, zip perde ve şeffaf branda gibi birbirinden farklı sistemleri kapsamaktadır.' },
                  { h3: 'Kalite ve Dayanıklılık', p: 'Kullandığımız alüminyum profiller ve teknik kumaşlar, Ege ikliminin güçlü güneşine, kuvvetli rüzgarına ve nem oranına karşı uzun yıllar dayanacak şekilde seçilmektedir. Motorlu sistemlerde tercih ettiğimiz mekanizmalar sessiz çalışması ve uzun ömrüyle öne çıkar.' },
                  { h3: 'Kullanım Alanına Göre Doğru Seçim', p: 'Dar bir balkon için mafsallı veya kasetli tente idealken, geniş teras ve bahçe alanları için bioklimatik ya da otomatik pergola daha uygun olabilir. Dört mevsim kullanım gerektiren mekânlarda zip perde veya şeffaf branda kombinasyonu tercih edilmektedir.' },
                ],
                bullets: ['Kasetli, körüklü ve mafsallı tente seçenekleri', 'Bioklimatik ve otomatik pergola sistemleri', 'Zip perde ve şeffaf branda çözümleri', 'Ücretsiz keşif ve yerinde model önerisi'],
              },
              {
                h2: 'izmirdetenteci.com Güvenilir Mi?',
                items: [
                  { h3: 'Deneyim ve Uygulama Disiplini', p: '<strong>izmirdetenteci.com</strong>, İzmir\'in farklı ilçelerinde tamamladığı 500\'ü aşkın proje ile sektörde güvenilir bir referans noktasına ulaşmıştır. Her uygulama, ölçüm hassasiyetinden montaj kalitesine kadar belirli standartlar çerçevesinde yürütülür.' },
                  { h3: 'Müşteri Memnuniyeti ve Referanslar', p: 'Müşterilerimizin büyük çoğunluğu, çevre ve komşu tavsiyesiyle bize ulaşmaktadır. Karşıyaka\'dan Menemen\'e, Bornova\'dan Narlıdere\'ye kadar İzmir\'in pek çok ilçesinde tamamladığımız projeler, sunduğumuz hizmetin kalitesini ortaya koymaktadır.' },
                  { h3: 'Keşif, Ölçüm ve Planlama Süreci', p: 'Tüm projelerimiz, yerinde yapılan ücretsiz keşif ve ölçümle başlar. Bu aşamada alanın teknik özellikleri, kullanım ihtiyaçları ve bütçe beklentisi birlikte değerlendirilir. Keşif sonrasında net bir teklif sunulur; sürpriz maliyet yaşanmaz.' },
                ],
                bullets: ['500+ tamamlanan proje deneyimi', 'Tavsiye ile gelen müşteri oranı yüksek', 'Teslim sonrası destek hattı', 'Şeffaf fiyatlandırma politikası'],
              },
              {
                h2: 'İzmir Tente Firmaları (2026)',
                items: [
                  { h3: 'Profesyonel Hizmet Anlayışı', p: 'İzmir\'de tente ve dış mekan sistemi hizmeti sunan firmalar arasında öne çıkmak için yalnızca ürün kalitesi yeterli değildir; montaj sonrası destek, zamanında teslimat ve şeffaf iletişim de belirleyici unsurlardır.' },
                  { h3: 'Yerel İhtiyaca Uygun Çözümler', p: 'İzmir\'in iklim koşulları, bina tipleri ve yaşam alışkanlıkları, tente ve pergola seçimini doğrudan etkiler. Ege\'nin kuvvetli meltemleri, yoğun güneş ışığı ve yüksek nem oranı göz önünde bulundurularak yapılan ürün seçimi, uzun vadeli memnuniyetin temelini oluşturur.' },
                  { h3: 'Modern Sistem ve Uygulama Seçenekleri', p: '2026 itibarıyla tente ve pergola sistemleri; akıllı ev entegrasyonu, rüzgar sensörü ve uzaktan kumanda gibi özelliklerle çok daha işlevsel hale gelmiştir. Otomatik pergola ve motorlu zip perde sistemleri giderek daha fazla tercih edilmektedir.' },
                ],
                bullets: ['Montaj sonrası destek ve garanti', 'İzmir iklimine özel ürün seçimi', 'Akıllı ev uyumlu motorlu sistemler', 'Zamanında ve temiz montaj taahhüdü'],
              },
              {
                h2: 'İzmir Tente Fiyatları (2026 Güncel)',
                items: [
                  { h3: 'Fiyatı Belirleyen Unsurlar', p: 'Tente ve dış mekan sistemi fiyatları; alanın genişliği, seçilen model, kumaş kalitesi ve motorlu/manuel tercihine göre değişmektedir. Kasetli veya mafsallı tente, konut projeleri için ekonomik bir başlangıç noktası sunarken; bioklimatik pergola ve otomatik sistemler daha kapsamlı bütçeler için idealdir.' },
                  { h3: 'Kalite ve Maliyet Dengesi', p: 'Düşük fiyatlı ürünler kısa vadede cazip görünse de uzun vadede bakım ve yenileme maliyetleri toplam harcamayı artırabilir. <strong>izmirdetenteci.com</strong> olarak sunduğumuz ürünler, kalite-fiyat dengesi gözetilerek seçilmektedir.' },
                  { h3: 'Teklif ve Planlama Süreci', p: 'Kesin fiyat bilgisi için yerinde ölçüm şarttır. Telefon veya WhatsApp üzerinden randevu alarak ücretsiz keşif hizmetimizden yararlanabilirsiniz. Keşif sonrasında hazırlanan teklif, tüm malzeme ve işçilik maliyetlerini kapsar; gizli ücret uygulanmaz.' },
                ],
                bullets: ['Alan ve model bazlı şeffaf fiyatlandırma', 'Uzun ömürlü ürünle düşük toplam maliyet', 'Ücretsiz keşif ve net teklif', 'Gizli ücret uygulanmaz'],
              },
              {
                h2: 'İzmir\'de Hangi Alanlarda Hizmet Veriyoruz?',
                items: [
                  { h3: 'Konut ve Villa Projeleri', p: 'Karşıyaka, Bornova, Buca, Bayraklı ve Konak gibi yoğun yerleşim bölgelerindeki apartman balkonları ile Narlıdere, Balçova ve Gaziemir\'deki villa ve müstakil konutlar, en sık hizmet verdiğimiz alanlar arasındadır.' },
                  { h3: 'Kafe, Restoran ve Ticari Alanlar', p: 'Restoranlar, kafeler ve ticari işletmeler için dış mekân kapasitesini artıran tente ve pergola çözümleri sunuyoruz. Zip perde ve şeffaf branda kombinasyonuyla kış aylarında da açık alan kullanımı mümkün hale gelir.' },
                  { h3: 'Teras, Bahçe ve Dış Mekan Çözümleri', p: 'Geniş teras ve bahçe alanlarında bioklimatik pergola, otomatik pergola ve rollingroof sistemleri dört mevsim kullanım imkânı sunar. Çiğli, Menemen ve Bayraklı\'daki projelerde de aynı kalite ve hız anlayışıyla hizmet veriyoruz.' },
                ],
                bullets: ['Karşıyaka, Bornova, Buca ve tüm İzmir', 'Villa, konut ve teras projeleri', 'Kafe, restoran ve ticari dış alan çözümleri', 'Çiğli ve Menemen dahil tüm ilçeler'],
              },
            ].map((block, bi) => (
              <article key={bi}>
                <h2 className="font-heading text-2xl md:text-3xl text-[#0f1923] mb-6 pb-3 border-b border-[#f5f0e8]">
                  {block.h2}
                </h2>
                <div className="space-y-6">
                  {block.items.map((item, ii) => (
                    <div key={ii}>
                      <h3 className="font-body text-base font-semibold text-[#0f1923] mb-2 flex items-center gap-2">
                        <span className="w-1.5 h-4 bg-[#d4a853] rounded-full flex-shrink-0"></span>
                        {item.h3}
                      </h3>
                      <p className="font-body text-[#6b7280] text-sm leading-relaxed" dangerouslySetInnerHTML={{ __html: item.p }}></p>
                    </div>
                  ))}
                </div>
                <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-2">
                  {block.bullets.map((b) => (
                    <li key={b} className="flex items-center gap-2 font-body text-sm text-[#6b7280]">
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-line text-[#d4a853]"></i>
                      </div>
                      {b}
                    </li>
                  ))}
                </ul>
              </article>
            ))}

          </div>

          {/* Sidebar */}
          <aside className="lg:col-span-1">
            <div className="sticky top-24 space-y-5">

              <div className="bg-[#0f1923] rounded-2xl p-6">
                <p className="font-body text-[#d4a853] text-xs font-semibold uppercase tracking-widest mb-3">Hızlı İletişim</p>
                <p className="font-heading text-lg text-white mb-4 leading-snug">Ücretsiz keşif talep edin</p>
                <div className="flex flex-col gap-3">
                  <a href="tel:05362771709" className="flex items-center justify-center gap-2 bg-[#d4a853] text-[#0f1923] font-body font-semibold px-5 py-3 rounded-lg hover:bg-[#e8c47a] transition-colors cursor-pointer whitespace-nowrap text-sm">
                    <i className="ri-phone-fill"></i>Hemen Ara
                  </a>
                  <a href="https://wa.me/905362771709" target="_blank" rel="noopener noreferrer nofollow" className="flex items-center justify-center gap-2 border border-white/15 text-white/70 font-body font-medium px-5 py-3 rounded-lg hover:border-[#d4a853] hover:text-[#d4a853] transition-all cursor-pointer whitespace-nowrap text-sm">
                    <i className="ri-whatsapp-fill"></i>WhatsApp&apos;tan Yaz
                  </a>
                </div>
              </div>

              <div className="bg-[#f5f0e8] rounded-2xl p-6">
                <p className="font-body text-[#d4a853] text-xs font-semibold uppercase tracking-widest mb-4">Hizmet Bölgeleri</p>
                <div className="flex flex-wrap gap-1.5">
                  {regions.map((r) => (
                    <span key={r} className="font-body text-xs text-[#6b7280] bg-white border border-[#ede5d5] px-2.5 py-1 rounded-full">{r}</span>
                  ))}
                </div>
              </div>

              <div className="border border-[#f5f0e8] rounded-2xl p-6">
                <p className="font-body text-[#d4a853] text-xs font-semibold uppercase tracking-widest mb-4">Popüler Hizmetler</p>
                <ul className="flex flex-col gap-2">
                  {sidebarServices.map((s) => (
                    <li key={s.href}>
                      <Link to={s.href} className="flex items-center gap-2 font-body text-sm text-[#6b7280] hover:text-[#d4a853] transition-colors cursor-pointer">
                        <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                          <i className="ri-arrow-right-s-line text-[#d4a853]"></i>
                        </div>
                        {s.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

            </div>
          </aside>

        </div>
      </div>
    </section>
  );
}
